import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { Button } from "../components/ui/button";
import Reveal from "../components/Reveal";
import SectionLabel from "../components/SectionLabel";
import { useSite, resolveImg } from "../context/SiteContext";

export default function Packages() {
  const { packages } = useSite();
  return (
    <main data-testid="packages-page" className="pt-32 pb-24">
      <section className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <SectionLabel>Tour Packages</SectionLabel>
          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-light max-w-4xl text-balance">
            Carefully composed <em className="not-italic font-medium">journeys</em>.
          </h1>
          <p className="mt-6 text-muted-foreground max-w-2xl">
            Five signature itineraries — from a weekend in Meghalaya to a fortnight across the seven sisters.
          </p>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {packages.map((p, i) => (
            <Reveal key={p.id} delay={(i % 3) * 0.08}>
              <div className="group rounded-3xl overflow-hidden border border-border bg-card hover:shadow-2xl transition-all duration-500 h-full flex flex-col">
                <div className="relative h-64 overflow-hidden">
                  <img src={resolveImg(p.cover)} alt={p.title} className="h-full w-full object-cover group-hover:scale-110 transition-transform duration-[1200ms]" />
                  {p.badge && <div className="absolute top-4 right-4 rounded-full bg-primary text-primary-foreground px-3 py-1 text-xs">{p.badge}</div>}
                  <div className="absolute top-4 left-4 glass rounded-full px-3 py-1 text-xs">{p.days}D · {p.nights}N</div>
                </div>
                <div className="p-6 flex-1 flex flex-col">
                  <h3 className="font-display text-2xl mb-2">{p.title}</h3>
                  <p className="text-sm text-muted-foreground mb-4">{(p.places || []).join(" · ")}</p>
                  <ul className="mt-2 space-y-2 text-sm flex-1">
                    {(p.inclusions || []).map((inc) => (
                      <li key={inc} className="flex items-start gap-2">
                        <CheckCircle2 className="h-4 w-4 text-primary mt-0.5" /> {inc}
                      </li>
                    ))}
                  </ul>
                  <div className="flex items-center justify-between pt-5 mt-5 border-t border-border">
                    <div>
                      <div className="text-xs text-muted-foreground">From</div>
                      <div className="font-display text-xl">₹{(p.price || 0).toLocaleString("en-IN")}</div>
                    </div>
                    <Link to={`/booking/${p.id}`}>
                      <Button data-testid={`pkg-book-${p.id}`} className="rounded-full" size="sm">Book Now</Button>
                    </Link>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
